import { supabase } from "./supabase";

const EMPRESA_ID = "ff438dc8-89fb-4d7c-9ea2-7e09162f242a";

/**
 * Registra um evento no system_audit_log do Supabase.
 * Fire-and-forget — nunca bloqueia o fluxo principal.
 */
export const audit = ({
  usuario_nome,
  usuario_role,
  acao,
  modulo,
  tabela,
  descricao,
}) => {
  supabase
    .from("system_audit_log")
    .insert({
      empresa_id: EMPRESA_ID,
      usuario_nome: usuario_nome || "sistema",
      usuario_role: usuario_role || null,
      acao,
      modulo: modulo || null,
      tabela: tabela || "sistema",
      descricao: descricao || null,
      created_at: new Date().toISOString(),
    })
    .then(({ error }) => {
      if (error) console.error("[Audit]", acao, error);
    });
};
